import { useEffect } from 'react'

interface DocumentMeta {
  title: string
  description?: string | undefined
}

const setMetaDescription = (content: string): void => {
  let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]')
  if (!tag) {
    tag = document.createElement('meta')
    tag.name = 'description'
    document.head.appendChild(tag)
  }
  tag.content = content
}

/**
 * Keeps the document title and description in step with the active route.
 * A deliberately small stand-in for a full head manager — enough for a
 * client-rendered site of this size.
 */
export const useDocumentMeta = ({ title, description }: DocumentMeta): void => {
  useEffect(() => {
    document.title = title
    if (description) setMetaDescription(description)
  }, [title, description])
}
